import React from 'react'
import { Button, Tag } from '@carbon/react'
import styles from './AttemptHeader.module.scss'
import { ArrowLeft, Time } from '@carbon/icons-react'
import { formatDurationSecondsClock } from '@sphere/shared/util'

interface AttemptHeaderProps {
  title?: string
  description?: string | null
  status?: string
  studentName?: string
  activityId?: string
  /** Durée en secondes (affichée en MM:SS). null = masquer le timer */
  durationSec?: number | null
}

export const AttemptHeader: React.FC<AttemptHeaderProps> = ({
  title,
  description,
  status,
  studentName,
  activityId,
  durationSec,
}) => {
  const handleBack = () => {
    if (activityId) {
      window.history.back()
    } else {
      window.history.back()
    }
  }

  return (
    <div className={styles.headerCard}>
      <div className={styles.headerTop}>
        <Button
          kind="ghost"
          size="sm"
          hasIconOnly
          renderIcon={ArrowLeft}
          iconDescription="Retour"
          onClick={handleBack}
        />
        <h2 className={styles.title}>{title}</h2>
        {durationSec != null && durationSec >= 0 && (
          <span className={styles.timer} title="Temps de réalisation">
            <Time size={16} className={styles.timerIcon} />
            {formatDurationSecondsClock(durationSec)}
          </span>
        )}
        {status && (
          <Tag type={status === 'COMPLETED' ? 'blue' : 'gray'} className="m-0">
            {status}
          </Tag>
        )}
      </div>

      {description && <p className={styles.description}>{description}</p>}

      {studentName && (
        <div className={styles.meta}>
          <span>
            Réalisé par : <strong>{studentName}</strong>
          </span>
        </div>
      )}
    </div>
  )
}
